export default "__VITE_ASSET__Bky43nH9__"